import { useState, useEffect } from 'react';
import {
  getAdminSummary, getAdminCategories,
  getAdminCreators, getAdminTopPosts, getAdminTimeseries,
} from '../APIs/adminApi';

const useAdminDashboard = (enabled = true) => {
  const [summary,     setSummary]     = useState(null);
  const [categories,  setCategories]  = useState([]);
  const [creators,    setCreators]    = useState([]);
  const [topPosts,    setTopPosts]    = useState([]);
  const [timeseries,  setTimeseries]  = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [error,       setError]       = useState(null);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const [sumRes, catRes, creatorsRes, postsRes, tsRes] = await Promise.all([
          getAdminSummary(),
          getAdminCategories(),
          getAdminCreators(10),
          getAdminTopPosts(7),
          getAdminTimeseries(30),
        ]);
        if (cancelled) return;
        setSummary(sumRes.data);
        setCategories(catRes.data.categories  || []);
        setCreators(creatorsRes.data.creators || []);
        setTopPosts(postsRes.data.posts       || []);
        setTimeseries(tsRes.data.timeseries   || []);
      } catch {
        if (!cancelled) setError('Admin data temporarily unavailable');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [enabled]);

  return { summary, categories, creators, topPosts, timeseries, loading, error };
};

export default useAdminDashboard;
